global.Widget3dsoft = require('./Ajax.js');

require('./Functions.js');
require('./Init.js');
require('./StepClient.js');
require('./StepDate.js');
require('./StepIntervention.js');
require('./StepValidation.js');
require('./StepVehicule.js');
require('./RdvAction.js');

global.ListeInterventions = require('./Class/ListeInterventions.js');

require('./StepAccueil.js');
require('./StepConfirmation.js');
require('./StepConnexion.js');
